import React, {useEffect} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { StyledTitles, StyledText, StyledMedio } from "./styles";
import Footer from "../components/commons/footer";
import { Link } from "react-router-dom";

function Medios() {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Container>
        <Row>
          <Col lg={12} style={{ marginTop: "50px" }}>
            <Link to={"/"} style={{ color: "#000" }}>
              <span
                style={{
                  background: "#E63457",
                  padding: "16px",
                  color: "white",
                  fontWeight: "bold",
                  borderRadius: "3px",
                }}
              >
                Volver
              </span>
            </Link>
          </Col>
        </Row>
        <Row>
          <StyledMedio lg={12} style={{ marginTop: "80px" }}>
            <StyledTitles>En esta página te vamos a mostrar algunas de las notas sobre LatamChequea o premios que nos ganamos en los últimos años</StyledTitles>
            <ul style={{marginBottom: '500px'}}>
              <li><a href="https://blogs.lanacion.com.ar/data/data-eventos/latam-chequea-el-primer-evento-regional-de-fact-checking-del-mundo/" rel="noreferrer" target="_blank" >Latam Chequea: el primer evento regional de fact-checking del mundo”</a>, La Nación, 2014.</li>
              <li><a href="https://premioggm.org/premio-gabo/edicion/2015/trabajos/innovacion/chequeado-2/"  rel="noreferrer" target="_blank" >Premio Gabriel García Márquez 2015</a>, a Chequeado en la Categoría innovación, entre otros aspectos, por su trabajo regional.</li>
              <li><a href="https://www.lanacion.com.ar/sociedad/mas-de-100-chequeadores-de-datos-del-mundo-se-reunen-en-buenos-aires-nid1906917/" rel="noreferrer" target="_blank" >“Más de 100 chequeadores de datos del mundo se reúnen en Buenos Aires”</a>, La Nación, 2016.</li>
              <li><a href="https://www.economist.com/the-americas/2018/07/14/latin-americas-new-media-are-growing-up" rel="noreferrer" target="_blank" >“Latin America’s new media are growing up”</a>, The Economist, 2018.</li>
              <li><a href="https://latamjournalismreview.org/articles/collaborative-fact-checking-project-in-latin-america-builds-platform-on-coronavirus-to-help-journalists/" rel="noreferrer" target="_blank" >“Collaborative fact-checking project in Latin America builds platform on coronavirus to help journalists”</a>, Knight Center Latam Journalism Review, 2020.</li>
              <li><a href="https://mondiplo.com/la-pandemia-y-el-sistema-mundo" rel="noreferrer" target="_blank" >“La pandemia y el sistema-mundo”</a>, Le Monde Diplomatique en español, 2020.</li>
            </ul>
            <StyledText>
            </StyledText>
          </StyledMedio>
        </Row>
      </Container>
      <Footer />
    </>
  );
}

export default Medios;
